import { get, post, put, deleteApi, patch } from "../../api/index";
import { API_ENDPOINTS, FALLBACK_DATA } from "../../constants";
import { writeDataToLocalStorage } from "../../utils/globalUtils";

const { APIS } = API_ENDPOINTS;

export const createUserGroupService = data =>
  new Promise((resolve, reject) => {
    post(APIS.USER_GROUPS, data)
      .then(response => {
        resolve(response.Usergroup);
      })
      .catch(error => {
        console.debug(`userService => createUserGroupService => ${error}`);
        reject(error);
      });
  });

export const deleteUserGroupByIdService = groupId =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.USER_GROUPS}/${groupId}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => deleteUserGroupByIdService => ${error}`);
        reject(error);
      });
  });

export const changeUserGroupStatusService = data =>
  new Promise((resolve, reject) => {
    put(`${APIS.USER_GROUPS}/${data.id}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `userService => changeUserGroupStatusService => ${error}`,
        );
        reject(error);
      });
  });

export const fetchUserGroupsService = () =>
  new Promise((resolve, reject) => {
    get(APIS.USER_GROUPS)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => fetchUserGroupsService => ${error}`);
        reject(error);
      });
  });

export const getTeammatesByGroupService = groupId =>
  new Promise((resolve, reject) => {
    get(`${APIS.GROUPS}/${groupId}/users`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => getTeammatesByGroupService => ${error}`);
        reject(error);
      });
  });

export const getAllTeammatesUsersService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.USERS}?confirmed_only=false`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllRolesService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.RBAC}/roles`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAllPermissionsService = () =>
  new Promise((resolve, reject) => {
    get(`${APIS.RBAC}/permissions`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const inviteUsersService = users =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTH}/invitations`, users)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const editInviteUsersService = userData =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTH}/invitations/${userData.user.id}`, userData)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const referralUsersService = users =>
  new Promise((resolve, reject) => {
    post(`${APIS.REFERRAL}`, users)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const disableEnableUserService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.USERS}/status`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const toggleRoleService = roleID =>
  new Promise((resolve, reject) => {
    patch(`${APIS.RBAC}/roles/${roleID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getRoleDetailsService = roleID =>
  new Promise((resolve, reject) => {
    get(`${APIS.RBAC}/roles/${roleID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getRoleDetailsWriteToLocalStrge = roles =>
  new Promise((resolve, reject) => {
    if (roles === null || (Array.isArray(roles) && roles.length === 0)) {
      writeDataToLocalStorage(
        "revvsalesUserPermissions",
        FALLBACK_DATA.FALLBACK_USER_PERMISSIONS,
      );
      resolve("success");
    } else {
      get(`${APIS.RBAC}/roles/${roles[0].id}`)
        .then(response => {
          writeDataToLocalStorage(
            "revvsalesUserPermissions",
            response.Role.permissions,
          );
          resolve(response);
        })
        .catch(error => {
          reject(error);
        });
    }
  });

export const updateRoleService = (roleID, data) =>
  new Promise((resolve, reject) => {
    put(`${APIS.RBAC}/roles/${roleID}`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const createRoleService = data =>
  new Promise((resolve, reject) => {
    post(`${APIS.RBAC}/roles`, data)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getSharedUserFeaturesService = (sharingHash, docId) =>
  new Promise((resolve, reject) => {
    get(`${APIS.USER_FEATURES}/documents/${docId}/${sharingHash}`)
      .then(response => {
        writeDataToLocalStorage("revvsalesUserFeatures", response.UserFeatures);
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getUserFeaturesService = () =>
  new Promise((resolve, reject) => {
    get(APIS.USER_FEATURES)
      .then(response => {
        writeDataToLocalStorage("revvsalesUserFeatures", response.UserFeatures);
        resolve(response);
      })
      .catch(error => {
        reject(error);
      });
  });

export const getAutoSignUsersService = () =>
  new Promise((resolve, reject) => {
    get(APIS.AUTOSIGN_USERS)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => getAutoSignUsersService => ${error}`);
        reject(error);
      });
  });

export const changeUserAutoSignStatusService = (userID, status) =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTOSIGN_USERS}/${userID}/status/${status}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `userService => changeUserAutoSignStatusService => ${error}`,
        );
        reject(error);
      });
  });

export const addAutoSignersService = users =>
  new Promise((resolve, reject) => {
    post(APIS.AUTOSIGN_USERS, users)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => addAutoSignersService => ${error}`);
        reject(error);
      });
  });

export const changeAutoSignerConsentService = status =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTOSIGN_CONSENT}/${status}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(
          `userService => changeAutoSignerConsentService => ${error}`,
        );
        reject(error);
      });
  });

export const saveAutoSignService = payload =>
  new Promise((resolve, reject) => {
    post(`${APIS.AUTOSIGN_CONSENT}/sign`, payload)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => saveAutoSignService => ${error}`);
        reject(error);
      });
  });

export const deleteAutoSignUserService = userID =>
  new Promise((resolve, reject) => {
    deleteApi(`${APIS.AUTOSIGN_USERS}/${userID}`)
      .then(response => {
        resolve(response);
      })
      .catch(error => {
        console.debug(`userService => deleteUserGroupByIdService => ${error}`);
        reject(error);
      });
  });
